import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { useEffect } from 'react';

import { showResult } from '../utils';
import { useSmsCampaignsQueryFilter } from './use-sms-campaigns-dashboard-filter';
import { CAMPAIGNS_PER_PAGE, getCampaignsQueryKey } from './use-get-campaigns';

import type { IUpdateSmsCampaign } from 'infrastructure/interfaces';

const mutationFn = async (postData: IUpdateSmsCampaign) => {
  const url = 'core-2/patients/sms-campaign';
  const { data, error } = await dataService.updateOnly<string[]>(url, postData);

  if (error) {
    return Promise.reject(error);
  }

  return data;
};

export const useUpdateCampaign = () => {
  const { filter } = useSmsCampaignsQueryFilter();
  const queryClient = useQueryClient();

  const { mutate, data, isLoading, error } = useMutation<
    string[] | undefined,
    string | undefined,
    IUpdateSmsCampaign
  >({
    mutationFn,
    onSuccess: () => {
      const filterWithItems = {
        ...filter,
        items: CAMPAIGNS_PER_PAGE,
      };
      const queryKey = getCampaignsQueryKey(filterWithItems);
      queryClient.invalidateQueries(queryKey);
      showResult();
    },
  });

  useEffect(() => {
    if (error) {
      showResult(error);
    }
  }, [error]);

  return { updateCampaign: mutate, data, isLoading };
};
